/**
 * Processor Name Enumeration
 */
export enum ProcessorNameEnum {
  ETPAYPLUS = "ETPayPlus Processor",
}



// WEBPACK FOOTER //
// ./src/shared/ProcessorNameEnum.ts